export default defineNuxtRouteMiddleware((to, from) => {
  const { emitEvent } = analyticsUtils();

  emitEvent('navigation', { route_change: `${from.path} -> ${to.path}` });
});
